import { render, staticRenderFns } from "./appHead.vue?vue&type=template&id=0c3bd5e8&scoped=true&"
import script from "./appHead.vue?vue&type=script&lang=js&"
export * from "./appHead.vue?vue&type=script&lang=js&"
import style0 from "./appHead.vue?vue&type=style&index=0&id=0c3bd5e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3bd5e8",
  null
  
)

export default component.exports